import React from "react";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import "./Terms.css";
import TermsHero from "../../components/pages/Terms/TermsHero/TermsHero";
import TermsContent from "../../components/pages/Terms/TermsContent/TermsContent";

const Terms = () => {
  return (
    <div className="terms-page">

      <div className="terms-page-content-guide">
              <Navbar theme="dark" />
      <TermsHero />
        <TermsContent />
      </div>
      <Footer />
    </div>
  );
};

export default Terms;